var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "A",
    cx: -254.817,
    cy: 705.837,
    gradientTransform: "matrix(2.827,1.6322,-1.6322,2.827,1967.2161,-1760.7166)",
    gradientUnits: "userSpaceOnUse",
    r: 82.973
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd24d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6c338"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "B",
    cx: -254.82,
    cy: 705.836,
    gradientTransform: "matrix(2.827,1.6322,-1.6322,2.827,1967.2161,-1760.7166)",
    gradientUnits: "userSpaceOnUse",
    r: 82.978
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4387fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#3078f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2b72ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#286ee6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.460432 0 0 .460432 57.509647 126.82041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-100.704-145.738l-24.2-41.9 45.3-78.5 24.2 41.9z",
    fill: "#0da960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-100.704-145.738l24.2-41.9h90.6l-24.2 41.9z",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.096-187.638h-48.4l-45.3-78.5h48.4z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55.404-187.638h-21.1l10.5-18.3-34.7 60.2z",
    fill: "#2d6fdd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-34.304-187.638h48.4l-58.9-18.3z",
    fill: "#e5b93c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-66.004-205.938l10.6-18.3-24.2-41.9z",
    fill: "#0c9b57"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/google-drive.16907554dd8359cb4537c65648d192dd.svg";
export { ForwardRef as ReactComponent };